import React from "react"
import styled from "styled-components"

const Button = ({ text, primary, large, small, smallFont, onClick }) => {
  return (
    <MenuButton
      primary={primary}
      large={large}
      small={small}
      smallFont={smallFont}
      onClick={onClick}
    >
      {text}
    </MenuButton>
  )
}

export default Button

const MenuButton = styled.button`
  text-align: center;
  border: 1px solid #5fcc9c;
  padding: 12px 0;
  /* width: 200px; */
  /* font-size: 1.35rem; */
  border-radius: 5px;
  cursor: pointer;

  font-size: ${props => (props.smallFont ? "1.15rem" : "1.35rem")};
  width: ${props => (props.large ? "200px" : props.small ? "100px" : "130px")};
  color: ${props => (props.primary ? "#fff" : "#5fcc9c")};
  background-color: ${props => (props.primary ? "#5fcc9c" : "#fff")};
`
